import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import {
  Badge,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap";
import { Videos360 } from "../../constants/videos";

import * as vars from "../../constants/constants";
import { messages } from "../../constants/messages";
import { movies } from "../../constants/movies";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { getVideoOrChannelRelatedData } from "../../actions/PlayActions";
import {
  addFavoriteChannel,
  addFavoriteVideo,
} from "../../actions/FavoriteActions";
import { showMessage } from "../../actions/FlashMessageActions";
import { setHeaderTitle } from "../../actions/HeaderActions";
import { console_log } from "../../utils/helper";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";
import { config } from "../../constants/domainConfig";
import { sendData } from "../../analytics/sendData";

class Favorites extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "2",
    };

    this.goToPlay = this.goToPlay.bind(this);
    this.channelFavorite = this.channelFavorite.bind(this);
    this.isChannelFavorite = this.isChannelFavorite.bind(this);
    this.videoFavorite = this.videoFavorite.bind(this);
    this.isVideoFavorite = this.isVideoFavorite.bind(this);
  }
  componentDidMount() {
    sendData("", "", "video", "viewed", { page: "favorites" });
    this.props.show();
    setTimeout(() => {
      this.props.hide();
    }, 1500);
    window.scrollTo(0, 0);
    const fav = {
      en: "Favorite",
      fr: "Préféré",
      ar: "المفضلة",
      cy: "Омиљено",
      ee: "Lemmik",
      es: "Favoritos",
      el: "Αγαπημένα",
      id: "Favorit",
      si: "Najljubše",
      pl: "Ulubione",
      th: "รายการโปรด"
    };
    this.props.setHeaderTitle(fav[config.lang]);
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  goToPlay(data, event) {
    event.preventDefault();
    if (
      event.target.tagName == "path" ||
      event.target.classList.contains("favoriteClick")
    ) {
      if (data.channel) {
        this.channelFavorite(data);
      } else {
        this.videoFavorite(data.video);
      }
    } else {
      this.props.getVideoOrChannelRelatedData(data);
      if (data.channel) {
        this.props.history.push("/play/channel");
      } else {
        this.props.history.push(
          `/play/video/?vid=${data.video.id}&uid=${this.props.account.user.uid}`
        );
      }
    }
  }

  channelFavorite(data) {
    let favoriteChannels = this.props.favorite.channels;
    let indexOf = favoriteChannels.findIndex((f) => {
      return f.channelId == data.channel.channelId;
    });
    let channelToBeUpdated = {
      channelId: data.channel.channelId,
      channelName: data.channel.channelName,
      channelLang: data.channel.channelLang,
      channelImage: data.channel.channelImage,
      channelLogo: data.channel.channelLogo,
      channelGrade: data.channel.channelGrade,
      channelStatus: data.channel.channelStatus,
      channelBaseline: data.channel.channelBaseline,
      channelCategories: data.channel.channelCategories,
      isFavorite: true,
    };

    if (indexOf == -1) {
      favoriteChannels.push(channelToBeUpdated);
      axios
        .post(vars.BASE_API_URL + "/favorites/channels", channelToBeUpdated)
        .then((response) => {
          this.props.showMessage({
            message: messages[config.lang].addToFavorites,
            type: true,
          });
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    } else {
      favoriteChannels.splice(indexOf, 1);
      axios
        .delete(
          vars.BASE_API_URL +
            "/favorites/channels/" +
            channelToBeUpdated.channelId
        )
        .then((response) => {
          this.props.showMessage({
            message: messages[config.lang].removeFromFavorites,
            type: false,
          });
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    }

    this.props.addFavoriteChannel(favoriteChannels);
  }

  videoFavorite(data) {
    let favoriteVideos = this.props.favorite.videos;
    let indexOf = favoriteVideos.findIndex((f) => {
      return f.videoId == data.id;
    });
    let videoToBeUpdated = {
      videoId: data.id,
      duration: data.duration,
      name: data.name[
        config.lang == "pt" || config.lang == "de" ? "en" : config.lang
      ],
      preview: data.preview,
    };

    if (indexOf == -1) {
      this.props.showMessage({
        message: messages[config.lang].addToFavorites,
        type: true,
      });
      favoriteVideos.push(videoToBeUpdated);
      axios
        .post(vars.BASE_API_URL + "/favorites/videos", videoToBeUpdated)
        .then((response) => {
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    } else {
      this.props.showMessage({
        message: messages[config.lang].removeFromFavorites,
        type: false,
      });
      favoriteVideos.splice(indexOf, 1);
      axios
        .delete(
          vars.BASE_API_URL + "/favorites/videos/" + videoToBeUpdated.videoId
        )
        .then((response) => {
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    }

    this.props.addFavoriteVideo(favoriteVideos);
  }

  isChannelFavorite(channelId) {
    let indexOf = this.props.favorite.channels.findIndex((f) => {
      return f.channelId == channelId;
    });

    if (indexOf != -1) {
      return true;
    }
    return false;
  }

  isVideoFavorite(videoId) {
    let indexOf = this.props.favorite.videos.findIndex((f) => {
      return f.videoId == videoId;
    });

    if (indexOf != -1) {
      return true;
    }
    return false;
  }

  goToPlayOthers(data, event) {
    event.preventDefault();
    if (
      event.target.tagName == "path" ||
      event.target.classList.contains("favoriteClick")
    ) {
      this.videoFavorite(data.video);
    } else {
      this.props.getVideoOrChannelRelatedData(data);
      this.props.history.push("/show");
    }
  }

  render() {
    const heartIcon =
      '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>';

    let favoriteChannelIds = this.props.favorite.channels.map(
      (c) => c.channelId
    );
    let favoriteChannels = this.props.category.channels.filter((channel) => {
      if (~favoriteChannelIds.indexOf(channel.channelId)) {
        return channel;
      }
    });
    let favoriteVideoIds = this.props.favorite.videos.map((v) => v.videoId);
    let favoriteVideos = [].concat
      .apply(
        [],
        Videos360.map((c) => c.videos)
      )
      .filter((v) => {
        if (~favoriteVideoIds.indexOf(v.id)) {
          return v;
        }
      });
    let favouriteRecentlyAdded = [];

    return (
      <section className="favorites">
        <Nav pills className="favorites__tabs">
          {/* <NavItem className="favorites__live">
		            	<NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggle('1'); }}>
							VR Videos
						</NavLink>
		            </NavItem> */}
          <NavItem className="favorites__vod">
            <NavLink></NavLink>
          </NavItem>
        </Nav>
        <TabContent
          className="favorites__content"
          activeTab={this.state.activeTab}
        >
          {/* <TabPane tabId="1">
                        <Row>
		                    <Col sm="12">
                                {(favoriteChannels.length > 0)?
                                    <div className="grid-list-row favorites-row">
                                        {favoriteChannels.map((channel) => {
                                            return (
                                                <div key={channel.channelId} className="grid-list-col favorites-col">
                                                    <div className="list-view" onClick={this.goToPlay.bind(this, {channel: channel})}>
                                                        <div className="channels-thumb channels-thumb--genre">
                                                            <div className="channels-image channels-image--genre no-radius">
                                                                <img className="channels-thumb__image channels-thumb__image--genre rounded-0 no-radius" src={channel.channelImage ? vars.BASE_URL+"uploads/"+channel.channelImage : "./img/thumbnail-2.jpg"} alt={channel.channelName}/>
                                                                <img className="channels-thumb__icon" src={channel.channelLogo} alt={channel.channelName} />
                                                            </div>
                                                        </div>
                                                        <div className="channels-thumb__details">
                                                            <div className="channels-thumb__fav">
                                                                <input className="icon-toggle favoriteClick" id={'tv'+channel.channelId} type="checkbox" checked={this.isChannelFavorite(channel.channelId)} onChange={() => {}}/>
                                                                <label className="icon-toggle-label favoriteClick" htmlFor={'tv'+channel.channelId}>
                                                                    <span className="favoriteClick"><i className="fa fa-star favoriteClick" aria-hidden="true"></i></span>
                                                                </label>
                                                            </div>
                                                            <div className="channels-thumb__inner">
                                                                <div className="channels-thumb__name">
                                                                    {channel.channelName}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                :   <div className="no-favorites__pane">
                                        <h4 className="favorites__pane__title">No Videos Added To favorites Yet</h4>
                                        <p className="favorites__pane__text">Add your favorite videos to access and watch easily without any hassles.</p>
                                    </div>
                                }
		                        <div className="text-center">
		                        	<a className="common-btn common-btn--brown common-btn--fav" href="/#/category/tv"><span className="common-btn__text">Explore VR Videos</span></a>
		                        </div>
		                    </Col>
                        </Row>
		            </TabPane> */}
          <TabPane tabId="2">
            <Row>
              <Col sm="12">
                {favoriteVideos.length > 0 ||
                favouriteRecentlyAdded.length > 0 ? (
                  <div className="grid-list-row favorites-row">
                    {favoriteVideos.map((video) => {
                      return (
                        <div
                          key={video.id}
                          className="grid-list-col favorites-col"
                        >
                          <div
                            className="list-view"
                            onClick={this.goToPlay.bind(this, { video: video })}
                          >
                            <div className="channels-thumb channels-thumb--genre">
                              <div className="channels-image channels-image--genre no-radius">
                                <img
                                  className="channels-thumb__image channels-thumb__image--genre rounded-0 no-radius"
                                  src={video.preview}
                                  alt={
                                    video.name[
                                      config.lang == "pt" || config.lang == "de"
                                        ? "en"
                                        : config.lang
                                    ]
                                  }
                                />
                              </div>
                            </div>
                            <div className="channels-thumb__details">
                              <div className="channels-thumb__fav">
                                <input
                                  className="icon-toggle favoriteClick"
                                  id={"vod" + video.id}
                                  type="checkbox"
                                  checked={this.isVideoFavorite(video.id)}
                                  onChange={() => {}}
                                />
                                <label
                                  className="icon-toggle-label favoriteClick"
                                  htmlFor={"vod" + video.id}
                                >
                                  <span className="favoriteClick">
                                    <i
                                      className="fa fa-star favoriteClick"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                </label>
                              </div>
                              <div className="channels-thumb__inner">
                                <div className="channels-thumb__name">
                                  {video.name[config.lang]
                                    ? video.name[config.lang]
                                    : video.name["en"]}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {favouriteRecentlyAdded.map((video) => {
                      return (
                        <div
                          key={video.id}
                          className="grid-list-col favorites-col"
                        >
                          <div
                            className="list-view"
                            onClick={this.goToPlayOthers.bind(this, {
                              video: video,
                            })}
                          >
                            <div className="channels-thumb channels-thumb--genre">
                              <div className="channels-image channels-image--genre no-radius">
                                <img
                                  className="channels-thumb__image channels-thumb__image--genre rounded-0 no-radius"
                                  src={video.preview}
                                  alt={
                                    video.name[
                                      config.lang == "pt" || config.lang == "de"
                                        ? "en"
                                        : config.lang
                                    ]
                                  }
                                />
                              </div>
                            </div>
                            <div className="channels-thumb__details">
                              <div className="channels-thumb__fav">
                                <input
                                  className="icon-toggle favoriteClick"
                                  id={"vod" + video.id}
                                  type="checkbox"
                                  checked={this.isVideoFavorite(video.id)}
                                  onChange={() => {}}
                                />
                                <label
                                  className="icon-toggle-label favoriteClick"
                                  htmlFor={"vod" + video.id}
                                >
                                  <span className="favoriteClick">
                                    <i
                                      className="fa fa-star favoriteClick"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                </label>
                              </div>
                              <div className="channels-thumb__inner">
                                <div className="channels-thumb__name">
                                  {video.name[config.lang]
                                    ? video.name[config.lang]
                                    : video.name["en"]}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="no-favorites__pane">
                    <h4 className="favorites__pane__title">
                      <FormattedMessage
                        id="noVideos"
                        defaultMessage="No Videos Added To Watch Later Yet"
                      />
                    </h4>
                    <p className="favorites__pane__text">
                      <FormattedMessage
                        id="addYourFav"
                        defaultMessage="Add your favorite videos to access and watch easily without any hassles."
                      />
                    </p>
                  </div>
                )}

                <div className="text-center">
                  <a
                    className="common-btn common-btn--pink common-btn--fav"
                    href="/#/category/vod"
                  >
                    <span className="common-btn__text">
                      <FormattedMessage
                        id="explore"
                        defaultMessage="Explore VR Videos"
                      />
                    </span>
                  </a>
                </div>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      getVideoOrChannelRelatedData,
      addFavoriteChannel,
      addFavoriteVideo,
      showMessage,
      setHeaderTitle,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Favorites);



// WEBPACK FOOTER //
// ./src/components/Favorites/Favorites.js